import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

export const translateHttpLoaderProvider = provideTranslateHttpLoader({
  prefix: './assets/i18n/',
  suffix: '.json'
});
